/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsissuerown2Inputs */

const en_ticketsissuerown2 = /** @type {(inputs: Ticketsissuerown2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This profile sells as its own company`)
};

const de_ticketsissuerown2 = /** @type {(inputs: Ticketsissuerown2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Profil verkauft als eigene Firma`)
};

/**
* | output |
* | --- |
* | "This profile sells as its own company" |
*
* @param {Ticketsissuerown2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsissuerown2 = /** @type {((inputs?: Ticketsissuerown2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsissuerown2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsissuerown2(inputs)
	return de_ticketsissuerown2(inputs)
});
export { ticketsissuerown2 as "ticketsIssuerOwn" }